/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsIdLeaveMutationResponse,
  PostTeamsIdLeavePathParams,
  PostTeamsIdLeave400,
  PostTeamsIdLeave401,
  PostTeamsIdLeave500,
} from "../types/PostTeamsIdLeave.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsIdLeaveMutationKey = () =>
  [{ url: "/teams/:id/leave" }] as const;

export type PostTeamsIdLeaveMutationKey = ReturnType<
  typeof postTeamsIdLeaveMutationKey
>;

/**
 * @summary Покинуть команду (для обычных участников)
 * {@link /teams/:id/leave}
 */
export async function postTeamsIdLeave(
  id: PostTeamsIdLeavePathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTeamsIdLeaveMutationResponse,
    ResponseErrorConfig<
      PostTeamsIdLeave400 | PostTeamsIdLeave401 | PostTeamsIdLeave500
    >,
    unknown
  >({ method: "POST", url: `/teams/${id}/leave`, ...requestConfig });
  return res;
}

export function postTeamsIdLeaveMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = postTeamsIdLeaveMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsIdLeaveMutationResponse>,
    ResponseErrorConfig<
      PostTeamsIdLeave400 | PostTeamsIdLeave401 | PostTeamsIdLeave500
    >,
    { id: PostTeamsIdLeavePathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return postTeamsIdLeave(id, config);
    },
  });
}

/**
 * @summary Покинуть команду (для обычных участников)
 * {@link /teams/:id/leave}
 */
export function usePostTeamsIdLeave<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsIdLeaveMutationResponse>,
      ResponseErrorConfig<
        PostTeamsIdLeave400 | PostTeamsIdLeave401 | PostTeamsIdLeave500
      >,
      { id: PostTeamsIdLeavePathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTeamsIdLeaveMutationKey();

  const baseOptions = postTeamsIdLeaveMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsIdLeaveMutationResponse>,
    ResponseErrorConfig<
      PostTeamsIdLeave400 | PostTeamsIdLeave401 | PostTeamsIdLeave500
    >,
    { id: PostTeamsIdLeavePathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsIdLeaveMutationResponse>,
    ResponseErrorConfig<
      PostTeamsIdLeave400 | PostTeamsIdLeave401 | PostTeamsIdLeave500
    >,
    { id: PostTeamsIdLeavePathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsIdLeaveMutationResponse>,
    ResponseErrorConfig<
      PostTeamsIdLeave400 | PostTeamsIdLeave401 | PostTeamsIdLeave500
    >,
    { id: PostTeamsIdLeavePathParams["id"] },
    TContext
  >;
}
